import Modal from "../Modal";
import { useMutation, useQuery } from "@apollo/client";
import { CREATE_OTP, GET_USER, LOGIN, RESET_PASSWORD, VERIFY_OTP } from "../../../graphql/auth";
import GInput from "../base/GInput";
import GCheckbox from "../base/GCheckbox";
import GButton from "../base/GButton";
import { useEffect, useState } from "react";
import useMainStore from "../../../store/mainState";
import { useTranslation } from "react-i18next";


const ResetPassword = () => {
    const { t } = useTranslation();
    const [identifier, setIdentifier] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const { isResetPasswordOpen, setIsResetPasswordOpen, setIsSignInOpen, environment } = useMainStore();
    const [createOtp, { data: createOtpData, loading: createOtpLoading, error: createOtpError }] = useMutation(CREATE_OTP);
    const [verifyOtp, { data: verifyOtpData, loading: verifyOtpLoading, error: verifyOtpError }] = useMutation(VERIFY_OTP);
    const [resetPassword, { data: resetPasswordData, loading: resetPasswordLoading, error: resetPasswordError }] = useMutation(RESET_PASSWORD);
    const [otpTitle, setOtpTitle] = useState("resetPassword.enterEmailPhone");
    const [flow, setFlow] = useState("OTPSend"); // OTPSend, OTPVerify, ResetPassword
    const [otpCode, setOtpCode] = useState("");
    const [otpId, setOtpId] = useState("");
    const [loading, setLoading] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [method, setMethod] = useState<"EMAIL" | "SMS">("EMAIL");

    const onSetIdentifier = (value: string) => {
        setIdentifier(value);
        setErrorMessage("");
    }

    // useEffect(() => {
    //   return () => {
    //     console.log("ResetPassword unmount");
    //     setFlow("OTPSend");
    //     setOtpCode("");
    //     setOtpId("");
    //   }
    // }, []);

    const onOpenSignIn = () => {
        setIsResetPasswordOpen(false);
        setIsSignInOpen(true);
    }

    const OnGetOtp = async () => {
        try {
            setLoading(true);
            if (!identifier) {
                setErrorMessage(t('resetPassword.pleaseEnterEmailPhone'));
                return;
            } else {
                const phoneRegex = /^\+?[0-9]{7,15}$/;

                setErrorMessage("");
                const method = phoneRegex.test(identifier) ? "SMS" : "EMAIL";
                setMethod(method);
                if (method === "EMAIL") {
                    //chek if email is valid
                    if (!identifier.includes("@") || !identifier.includes(".")) {
                        setErrorMessage(t('resetPassword.invalidEmail'));
                        return;
                    }
                }

                const input = {
                    identifier: identifier,
                    method: method,
                    environmentId: environment.id,
                    type: "FORGET_PASSWORD",
                    providerId: 2 ////todo: get from config
                }

                const data = await createOtp({
                    variables: {
                        input: input
                    }
                })
                if (data?.data) {
                    if (data?.data?.createOtp?.success) {
                        setFlow("OTPVerify");
                        setOtpTitle("resetPassword.enterOtp");
                        setOtpId(data?.data?.createOtp?.id);
                    } else {
                        setErrorMessage(data?.data?.createOtp?.message || t('resetPassword.failedSendOtp'));
                    }
                    setLoading(false);
                    // setIsSignInOpen(false);
                    // setIsResetPasswordOpen(true);
                } else {
                    setErrorMessage(t('resetPassword.failedSendOtp'));
                    setLoading(false);
                }
            }

        } catch (error) {
            setErrorMessage(t('resetPassword.failedSendOtp'));
            console.log(error);
            setLoading(false);
        }
    }

    const OnVerifyOtp = async () => {
        try {
            setLoading(true);

            const data = await verifyOtp({
                variables: {
                    input: {
                        otpId: otpId,
                        code: otpCode
                    }
                }
            })
            if (data?.data) {
                console.log({ data });
                if (data?.data?.verifyOtp?.success) {
                    setFlow("ResetPassword");
                    setOtpTitle("resetPassword.enterNewPassword")
                    setOtpCode("");
                    setOtpId("");
                } else {
                    setErrorMessage(data?.data?.verifyOtp?.message || t('resetPassword.failedVerifyOtp'));
                }
                setLoading(false);
            } else {
                setErrorMessage(t('resetPassword.failedVerifyOtp'));
                setLoading(false);
            }
        } catch (error) {
            setErrorMessage(t('resetPassword.failedVerifyOtp'));
            console.log(error);
            setLoading(false);
        }
    }

    const OnResetPassword = async () => {
        if (!newPassword || !confirmPassword) {
            setErrorMessage(t('resetPassword.fillAllFields'));
            return;
        }
        if (newPassword !== confirmPassword) {
            setErrorMessage(t('resetPassword.passwordsNoMatch'));
            return;
        }
        try {
            setLoading(true);
            const data = await resetPassword({
                variables: {
                    input: {
                        identifier: identifier,
                        method: method,
                        environmentId: environment.id,
                        password: newPassword,
                        password_confirmation: confirmPassword
                    }
                }
            })
            console.log({ data });
            if (data?.data?.resetPassword) {
                setIsResetPasswordOpen(false);
                setIsSignInOpen(true);
            } else {
                setErrorMessage(data?.data?.resetPassword?.message || t('resetPassword.failedResetPassword'));
            }
            setLoading(false);
        } catch (error) {
            setErrorMessage(t('resetPassword.failedResetPassword'));
            console.log(error);
            setLoading(false);
        }
    }

    const onPasswordChange = (value: string) => {
        setNewPassword(value);
        setErrorMessage("");
    }

    const onConfirmPasswordChange = (value: string) => {
        setConfirmPassword(value);
        setErrorMessage("");
    }

    return (
        <Modal loading={loading} isOpen={isResetPasswordOpen} onClose={() => { setIsResetPasswordOpen(false) }} title={t('resetPassword.title')} subTitle={t(otpTitle)} leftContent={<img src={require("../../../assets/images/signIn.webp")} alt="" className="h-full object-fill w-full" />}>
            {flow === "OTPSend" && (
                <div>
                    {errorMessage && (
                        <div className="mb-4 p-3 bg-red-500/20 border border-red-500 rounded-lg">
                            <p className="text-red-500 text-sm font-medium">{errorMessage}</p>
                        </div>
                    )}
                    <GInput required className={errorMessage ? "w-full border-red-500" : "w-full"} label={t('resetPassword.emailPhone')} type="text" placeholder={t('resetPassword.emailPhone')} onChange={(e) => onSetIdentifier(e.target.value)} />
                    <GButton disabled={!identifier} className="w-full py-[20px] " onClick={OnGetOtp} isGradient={true}>{t('resetPassword.getOtp')}</GButton>
                </div>
            )}
            {flow === "OTPVerify" && (
                <div>
                    {errorMessage && (
                        <div className="mb-4 p-3 bg-red-500/20 border border-red-500 rounded-lg">
                            <p className="text-red-500 text-sm font-medium">{errorMessage}</p>
                        </div>
                    )}
                    <GInput required className="w-full" label={t('resetPassword.otpCode')} type="text" placeholder={t('resetPassword.otpCode')} onChange={(e) => setOtpCode(e.target.value)} />
                    <GButton disabled={!otpCode} className="w-full py-[20px] " onClick={OnVerifyOtp} isGradient={true}>{t('resetPassword.verifyOtp')}</GButton>
                    <div className="flex justify-center mt-4">
                        <span className="text-white text-[19px] font-medium cursor-pointer" onClick={OnGetOtp}>{t('resetPassword.resendOtp')}</span>
                    </div>
                </div>
            )}
            {flow === "ResetPassword" && (
                <div>
                    {errorMessage && (
                        <div className="mb-4 p-3 bg-red-500/20 border border-red-500 rounded-lg">
                            <p className="text-red-500 text-sm font-medium">{errorMessage}</p>
                        </div>
                    )}
                    <GInput required className="w-full" label={t('resetPassword.newPassword')} type="password" placeholder={t('resetPassword.newPassword')} onChange={(e) => onPasswordChange(e.target.value)} />
                    <GInput required className="w-full" label={t('resetPassword.confirmPassword')} type="password" placeholder={t('resetPassword.confirmPassword')} onChange={(e) => onConfirmPasswordChange(e.target.value)} />
                    <GButton disabled={!newPassword || !confirmPassword} className="w-full py-[20px] " onClick={OnResetPassword} isGradient={true}>{t('resetPassword.resetPasswordBtn')}</GButton>
                </div>
            )}
        </Modal>
    )
}

export default ResetPassword